import {
  ConstrainedObject,
  ConstraintModifierField,
  IConstrainedObject,
  SelectedElement,
} from '@Models';
import { modifierIsActive } from '@Selectors/builder/myArmyList/common/constraints/conditions/modifier-is-active';

export const isHiddenItemConstraint = (
  item: IConstrainedObject,
  constrainedObjects: ConstrainedObject[],
  selectedElements: SelectedElement[],
  selectedElement: SelectedElement,
): boolean => {
  const modifiers = item.modifiers
    .filter((modifier) => modifier.field == ConstraintModifierField.Hidden)
    .filter((modifier) =>
      modifierIsActive(
        modifier,
        constrainedObjects,
        selectedElements,
        selectedElement,
      ),
    );

  if (modifiers.length == 0) return item.hidden;

  return modifiers.some((modifier) => modifier.value === 'true');
};
